// Copa: piso xadrez, bancada de pia, geladeira e cafeteira no alto (quem pega café fica em pé
// na frente dela) e duas mesas redondas e uma de café com cadeiras. A porta fica embaixo,
// entre as mesas.

import type { RoomMap, Spot } from '../../core/world.js';

// Cadeiras da mesa de café: uma fileira de cada lado, sentadas de frente uma para a outra.
const CAFE_SPOTS: readonly Spot[] = [
  { id: 'copa:cafe-0', x: 5, y: 4, facing: 'down', kind: 'chair', use: 'eat' },
  { id: 'copa:cafe-1', x: 6, y: 4, facing: 'down', kind: 'chair', use: 'eat' },
  { id: 'copa:cafe-2', x: 7, y: 4, facing: 'down', kind: 'chair', use: 'eat' },
  { id: 'copa:cafe-3', x: 5, y: 6, facing: 'up', kind: 'chair', use: 'eat' },
  { id: 'copa:cafe-4', x: 6, y: 6, facing: 'up', kind: 'chair', use: 'eat' },
  { id: 'copa:cafe-5', x: 7, y: 6, facing: 'up', kind: 'chair', use: 'eat' },
];

export const COPA: RoomMap = {
  id: 'copa',
  kind: 'kitchen',
  name: 'Copa',
  // x = piso xadrez
  floor: Array.from({ length: 8 }, () => 'xxxxxxxxxxxxxx'),
  legend: { x: 'piso-xadrez' },
  items: [
    // parede norte: cardápio, relógio, prateleira com canecas, calendário e ar-condicionado
    { item: 'quadro-avisos', x: 1, y: 0 },
    { item: 'relogio', x: 3, y: 0 },
    { item: 'prateleira-parede', x: 5, y: 0 },
    { item: 'calendario', x: 9, y: 0 },
    { item: 'poster-agzos', x: 11, y: 0 },
    { item: 'ar-condicionado', x: 12, y: 0 },
    // bancada de pia, geladeira, micro-ondas, cafeteira e máquina de snacks
    { item: 'balcao-pia', x: 0, y: 2 },
    { item: 'balcao-pia', x: 2, y: 2 },
    { item: 'geladeira', x: 4, y: 2 },
    { item: 'micro-ondas-balcao', x: 5, y: 2 },
    { item: 'balcao-pia', x: 6, y: 2 },
    { item: 'balcao-cafeteira', x: 8, y: 2 },
    { item: 'maquina-snacks', x: 9, y: 2 },
    { item: 'geladeira', x: 10, y: 2 },
    { item: 'balcao-pia', x: 11, y: 2 },
    { item: 'vaso-alto', x: 13, y: 2 },
    // mesas: redonda com cadeiras, mesa de café com cadeiras e a segunda redonda
    { item: 'mesa-redonda', x: 2, y: 5 },
    { item: 'mesa-cafe-retangular', x: 5, y: 5 },
    { item: 'mesa-redonda', x: 9, y: 5 },
    { item: 'cadeira-madeira', x: 5, y: 4 },
    { item: 'cadeira-madeira', x: 6, y: 4 },
    { item: 'cadeira-madeira', x: 7, y: 4 },
    { item: 'cadeira-madeira', x: 5, y: 6 },
    { item: 'cadeira-madeira', x: 6, y: 6 },
    { item: 'cadeira-madeira', x: 7, y: 6 },
    // cantos e detalhes: plantas, bebedouro, caixas de suprimentos e lixeira
    { item: 'planta-grande', x: 0, y: 4 },
    { item: 'bebedouro', x: 0, y: 6 },
    { item: 'caixas-papelao', x: 11, y: 6 },
    { item: 'planta-vaso', x: 13, y: 5 },
    { item: 'lixeira', x: 13, y: 7 },
  ],
  doors: [{ x: 6, y: 7 }],
  spots: CAFE_SPOTS,
};
